// Categoriile de cheltuieli, cu iconiță și culoare pentru fiecare.
import { UtensilsCrossed, Car, BedDouble, PartyPopper, Receipt } from "lucide-react";

export const CATEGORII = [
  { id: "mancare", label: "Mâncare", icon: UtensilsCrossed, color: "bg-orange-100 text-orange-600", hex: "#f97316" },
  { id: "transport", label: "Transport", icon: Car, color: "bg-sky-100 text-sky-600", hex: "#0ea5e9" },
  { id: "cazare", label: "Cazare", icon: BedDouble, color: "bg-violet-100 text-violet-600", hex: "#8b5cf6" },
  { id: "distractie", label: "Distracție", icon: PartyPopper, color: "bg-pink-100 text-pink-600", hex: "#ec4899" },
  { id: "altele", label: "Altele", icon: Receipt, color: "bg-slate-100 text-slate-600", hex: "#64748b" },
];

// Găsește categoria după id; dacă nu există, întoarce „Altele".
export function getCategorie(id) {
  return CATEGORII.find((c) => c.id === id) || CATEGORII[CATEGORII.length - 1];
}
